import React from 'react';
import './SettingsSkeleton.css';

const SettingsSkeleton: React.FC = () => {
  return (
    <div className="settings-page">
      <div className="settings-title skeleton-title-text" role="heading" aria-level={1} aria-label="Loading settings"></div>
      
      <div className="settings-layout">
        {/* Sidebar */}
        <div className="sidebar">
          <div className="skeleton-sidebar-tab"></div>
          <div className="skeleton-sidebar-tab"></div>
          <div className="skeleton-sidebar-tab"></div>
        </div>

        {/* Content Area */}
        <div className="settings-content">
          <div className="content-card skeleton-content-card">
            {/* Card Header */}
            <div className="skeleton-content-header"></div>
            
            {/* Profile Section */}
            <div className="skeleton-profile-section">
              <div className="skeleton-profile-image"></div>
              <div className="skeleton-profile-buttons">
                <div className="skeleton-button"></div>
                <div className="skeleton-button"></div>
              </div>
            </div>

            {/* Stats Grid */}
            <div className="skeleton-stats-grid">
              <div className="skeleton-stat-card">
                <div className="skeleton-stat-label"></div>
                <div className="skeleton-stat-value"></div>
              </div>
              <div className="skeleton-stat-card">
                <div className="skeleton-stat-label"></div>
                <div className="skeleton-stat-value"></div>
              </div>
              <div className="skeleton-stat-card">
                <div className="skeleton-stat-label"></div>
                <div className="skeleton-stat-value"></div>
              </div>
              <div className="skeleton-stat-card">
                <div className="skeleton-stat-label"></div>
                <div className="skeleton-stat-value"></div>
              </div>
            </div>

            {/* Info Rows */}
            <div className="skeleton-info-rows">
              <div className="skeleton-info-row">
                <div className="skeleton-info-label"></div>
                <div className="skeleton-info-value"></div>
              </div>
              <div className="skeleton-info-row">
                <div className="skeleton-info-label"></div>
                <div className="skeleton-info-value"></div>
              </div>
              <div className="skeleton-info-row">
                <div className="skeleton-info-label"></div>
                <div className="skeleton-info-value"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsSkeleton;
